
import normalizeWheel from 'normalize-wheel';
import onVisibilityChange from "visibility-change-ponyfill";

export default {
  //附加鼠标滚轮
  addMouseWheelEvent(el, callback) {
    if (el) {
      let isFirefox = dsf.client.type == 'FF';
      el.$$mousewheel = function (event) {
        const normalized = normalizeWheel(event);
        callback && callback.apply(this, [event, normalized]);
      }
      el.addEventListener(isFirefox ? 'DOMMouseScroll' : 'mousewheel', el.$$mousewheel);
    }
  },
  removeMouseWheelEvent(el) {
    if (el) {
      let isFirefox = dsf.client.type == 'FF'
      if (el.$$mousewheel) {
        el.addEventListener(isFirefox ? 'DOMMouseScroll' : 'mousewheel', el.$$mousewheel);
      }
    }
  },
  addVisiblityChangeEvent(callback){
    onVisibilityChange(callback)
  },
  removeVisiblityChangeEvent(callback){
    onVisibilityChange.remove(callback)
  }
}